module.exports = __webpack_public_path__ + "static/img/produce01.fbb14e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/technology/images/produce01.png
// module id = 131
// module chunks = 4